<template>
  <div class="md:w-full">
    <div v-if="user.is_admin || user.is_manager" class="m-2 px-2">
      <Link class="group flex items-center border-2 border-solid border-blue-600" href="/">
        <div class="text-blue group-hover:text-white group-hover:bg-blue-600 p-2">Dashboard</div>
      </Link>
    </div>

    <div class="m-2 px-2">
      <Link class="group flex items-center border-2 border-solid border-blue-600" href="/projects/create">
        <div class="text-blue group-hover:text-white group-hover:bg-blue-600 p-2">+ New Project</div>
      </Link>
    </div>

    <div class="m-2 px-2" :class="isUrl('projects') ? 'bg-blue-800' : ''">
      <Link class="group flex items-center py-2" :href="`/projects?owner=${name}`">
        <div :class="isUrl('projects') ? 'text-white' : 'text-blue-300 group-hover:text-white'">My Projects</div>
      </Link>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/vue3'
export default {
  components: {
    Link,
  },
  props: {
    user: {
      type: Object,
    },
  },
  computed: {
    name () {
      return this.user.first_name + ' ' + this.user.last_name
    },
  },
  methods: {
    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter((url) => currentUrl.startsWith(url)).length
    },
  },
}
</script>
